<template>
  <div id="app">
    <waterMark overlapStyle="height: 100%;" :text="waterMarktext" v-if="isShow"> </waterMark>
    <router-view />
  </div>
</template>
<script>

import waterMark from '@/components/waterMark'
const CURRENT_VERSION = '1.0.8';
export default {
  components: { waterMark},
  data() {
    return {
      waterMarktext:[],
      isShow:false
    }
  },
  watch: {
    '$route'(to, from) {
      this.routeFn(to)
      // 路由变化时会触发这个函数
      // 'to' 和 'from' 是两个路由对象
      // 你可以在这里根据路由变化执行相应的逻辑
    }
  },
  created(){
    console.log('created');
  },
   mounted() {
    this.checkForUpdates();
  },
  methods:{
    routeFn(to){
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        if(to.path === '/user/bind' || to.path === '/user/load_wx_config' || to.path === '/user/null'||to.path === '/home/clear_cache'){
          this.isShow = false;
        }else{
          this.waterMarktext = [`姓名：${userInfo.name}`, `手机号：${userInfo.phone}`];
          this.isShow = true;
        }
      }
    },
    /**
     * 检查应用是否有新版本并提示刷新。
     */
    checkForUpdates() {
      // 设置一个定时器，例如每分钟检查一次
      // Production apps might use a longer interval or a more sophisticated strategy like on window focus.
      const checkInterval = 3 * 1000; // 60秒

      setInterval(() => {
        console.log('Checking for application updates...');

        // 使用 fetch 请求 version.json 文件。
        // { cache: 'no-store' } 是关键，它确保了每次都从服务器获取最新文件，而不是从浏览器缓存。
        fetch('/version.json', { cache: 'no-store' })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            const latestVersion = data.version;
            console.log(`Current version: ${CURRENT_VERSION}, Latest version: ${latestVersion}`);
            
            // 如果服务器上的版本号与当前代码中的版本号不一致
            if (latestVersion !== CURRENT_VERSION) {
              console.log('New version detected! Reloading page...');
              
              // 强制浏览器从服务器重新加载页面，而不是从缓存中读取
              // `true` 参数在旧版浏览器中用于此目的，在现代浏览器中已不必要，但保留无害
              window.location.reload(true);
            }
          })
          .catch(error => {
            // 在生产环境中，这里应该使用更专业的日志记录
            console.error('Failed to check for updates:', error);
          });
      }, checkInterval);
    }
  }
}
</script>

<style lang="less"></style>
